import React, {Component, Fragment} from 'react';
import {Link} from 'react-router-dom'

import '../App.css';
class Home extends Component {
    render() {
        return (
            <Fragment>
                <div className="jumbotron" style={{ marginBottom: 0}} >
                <img src={require('../assets/bow_logo.png')}  alt="Outdoors-Woman"/>
                <h1 className="display-6" style={{textAlign:'center'}}>Becoming an Outdoors-Woman</h1>
                <h1 className="display-6"style={{textAlign:'center'}}>ARKANSAS GAME AND FISH COMMISSION</h1>
                    <h1 className="display-6"style={{textAlign:'center'}}>2018 WORKSHOP</h1>
                <p className="lead">Becoming an Outdoors-Woman is an outdoors skills workshop designed for women 18 years and older. The program focuses on providing opportunities for women to learn skills and encourage participation in hunting, fishing, and other outdoor activities.</p>
                <hr className="my-4"/>
                <p>A maximum of 135 women will be chosen to register for BOW. Priority is given to first time participants. Space is limited.</p>
                <Link className="btn btn-primary btn-lg" to="/bow/registration"  role="button">Register </Link>
                </div>
                <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                        <ol className="carousel-indicators">
                            <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                        </ol>
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                            <img  className="d-block w-100" src={require('../assets/bow.jpg')}   alt="First slide"/>
                            </div>
                            <div className="carousel-item">
                            <img className="d-block w-100" src={require('../assets/girlBoat.jpg')} alt="Second slide"/>
                            </div>
                            <div className="carousel-item">
                            <img className="d-block w-100" src={require('../assets/boating.jpg')} alt="Third slide"/>
                            </div>
                            <div className="carousel-item">
                            <img className="d-block w-100" src={require('../assets/dutchOven.jpg')} alt="Fourth slide"/>
                            </div>
                        </div>
                        <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="sr-only">Previous</span>
                        </a>
                        <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="sr-only">Next</span>
                        </a>
                    </div>
            </Fragment>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home_Page.jsx